import React from 'react';

const Item = ({title, description, icon, href, openTab = false}) => {

  return (
    <div className="item">
      <i className={`${icon} icon`}></i>
      <div className="content">
        <a className="header" href={href} target={`${openTab ? "_blank" : ""}`}>{title}</a>
        <div className="description">
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </div>
    </div>
  )
}

export default Item;